import axios from "@/utils/request";

export const checkDebugAccess = () => {
  return axios.request({
    url: "zswl_user/debug_access",
    method: "GET",
    skipAuth: true,
    headers: { Authorization: "" },
  });
};

export const newAccount = (data) => {
  return axios.request({
    url: "zswl_user/account",
    method: "POST",
    data,
  });
};

export const checkAccount = (data) => {
  return axios.request({
    url: "zswl_user/check",
    method: "POST",
    data
  })
};

export const isStaff = (data) => {
  return axios.request({
    url: "zswl_user/is_staff",
    method: "POST",
    data
  })
};

export const login = (data) => {
  return axios.request({
    url: "zswl_user/login",
    method: "POST",
    data,
  });
};

export const loadProducts = (params) => {
  return axios.request({
    url: "product/product/list",
    method: "GET",
    params,
  });
};

export const getProduct = (params) => {
  return axios.request({
    url: "product/product/detail",
    method: "GET",
    params,
  });
};

export const doLogin = (data) => {
  return axios.request({
    url: "user/zswl_login",
    method: "POST",
    data,
  });
};

export const doAccount = (data) => {
  return axios.request({
    url: "zswl_user/account",
    method: "POST",
    data,
  });
};

export const insert = (data) => {
  return axios.request({
    url: "/insert",
    method: "post",
    data,
  });
};
export const update = (data) => {
  return axios.request({
    url: "/update",
    method: "post",
    data,
  });
};
export const getList = (params) => {
  return axios.request({
    url: "zswl_user/index",
    method: "get",
    params,
  });
};

export const getSignDetail = () => {
  return axios.request({
    url: "shuguang_bag/getSignDetail",
    method: "get"
  });
};

export const getMyPrizeList = () => {
  return axios.request({
    url: "shuguang_bag/getMyPrizeList",
    method: "get"
  });
};

export const getStudentInfo = () => {
  return axios.request({
    url: "shuguang_bag/getStudentInfo",
    method: "get"
  })
};

export const saveStudentInfo = (data) => {
  return axios.request({
    url: "shuguang_bag/saveStudentInfo",
    method: "post",
    data,
  });
};

export const saveSignInfo = (data) => {
  return axios.request({
    url: "shuguang_bag/saveSignInfo",
    method: "post",
    data,
  });
};

export const signDraw = () => {
  return axios.request({
    url: "shuguang_bag/draw",
    method: "post"
  });
};

export const getPosterInfo = () => {
  return axios.request({
    url: "shuguang_bag/getPosterInfo",
    method: "get"
  });
};

export const getHasDraw = () => {
  return axios.request({
    url: "shuguang_bag/hasDraw",
    method: "get"
  });
};

export const findByMobile = (data) => {
  return axios.request({
    url: "zswl_user/find_by_mobile",
    method: "POST",
    data,
  });
};
